import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./Scss/index.scss";
import store from "./Global/store";
import { Provider } from "react-redux";

// Get root element
const rootElement = document.getElementById("root");

// Validate root element exists
if (!rootElement) {
  throw new Error(
    "Root element not found. Ensure index.html has a div with id='root'"
  );
}

// Create React root and render
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// Log app start in development
if (process.env.NODE_ENV === "development") {
  console.log("Facebook Clone App Started");
}

